export const ENDPOINTS = {
  INSTALL_SITE_APPS: '/api/install-site-apps',
  GENERATE_PRODUCT_PROFILE: '/api/generate-product-profile',
  GENERATE_PRODUCT_IMAGES: '/api/generate-product-images',
  MATCH_PRODUCT_CATEGORY: '/api/match-product-category',
};
